import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { promoCodesApi } from '../api/promo-codes.api';
import type { CreatePromoCodeDto, UpdatePromoCodeDto } from '../types';

export const usePromoCodes = () => {
  return useQuery({
    queryKey: ['promo-codes'],
    queryFn: () => promoCodesApi.getAll(),
  });
};

export const useCreatePromoCode = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreatePromoCodeDto) => promoCodesApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['promo-codes'] });
      notifications.show({
        title: 'Успешно',
        message: 'Промокод создан',
        color: 'green',
      });
    },
    onError: (error: any) => {
      notifications.show({
        title: 'Ошибка',
        message: error?.response?.data?.message || 'Не удалось создать промокод',
        color: 'red',
      });
    },
  });
};

export const useUpdatePromoCode = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: UpdatePromoCodeDto }) => promoCodesApi.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['promo-codes'] });
      notifications.show({
        title: 'Успешно',
        message: 'Промокод обновлён',
        color: 'green',
      });
    },
    onError: (error: any) => {
      notifications.show({
        title: 'Ошибка',
        message: error?.response?.data?.message || 'Не удалось обновить промокод',
        color: 'red',
      });
    },
  });
};

export const useDeletePromoCode = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => promoCodesApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['promo-codes'] });
      notifications.show({
        title: 'Успешно',
        message: 'Промокод удалён',
        color: 'green',
      });
    },
    onError: (error: any) => {
      notifications.show({
        title: 'Ошибка',
        message: error?.response?.data?.message || 'Не удалось удалить промокод',
        color: 'red',
      });
    },
  });
};
